import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public today: number = Date.now();
  copyRights = environment.copyRights;
  constructor() { }

  ngOnInit(): void {
  }

}
